// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"321c08c6","144":"aac24180","285":"13eaede0","415":"40440b77","426":"cbba773c","520":"94d7ae70","560":"ff86e4d1"}[chunkId] + ".chunk.js";
};